import apiWrapper, { extractApiData } from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
import {
  type SmsMessage,
  type SearchMessagesQueryParams,
  type SearchSmsBody,
  type SmsMessageDetails,
} from '../types/beMessageApi'
import { type PagedList } from '../types/beFiltersApi'

const endpoints = ((baseURL: string) => {
  return {
    searchSmsMessages: (idList: number, qs: SearchMessagesQueryParams) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/message/search?${encodeParams(qs) as unknown as string}`,
    getSmsMsgDetails: (idMessage: number) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}`,
  }
})(process.env.BESMSMESSAGE_URL as unknown as string)

export const beSmsMessageApiSearchSmsMessages = async (
  idList: number,
  params: SearchMessagesQueryParams,
  body: SearchSmsBody,
): Promise<PagedList<SmsMessage>> => {
  return await apiWrapper({
    method: 'post',
    url: endpoints.searchSmsMessages(idList, params),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(body),
  }).then(extractApiData)
}
export const beSmsMessageApiGetSmsMsgDetails = async (
  idMessage: number,
): Promise<SmsMessageDetails> => {
  return await apiWrapper({
    url: endpoints.getSmsMsgDetails(idMessage),
  }).then(extractApiData)
}
